import AppHeaderContext, { AppHeaderSection } from 'contexts/AppHeaderContext'
import { MutableRefObject, RefObject, useCallback, useContext, useEffect } from 'react'
import { ElementBoundingClientRectObserver, useElementBoundingClientRectObserver } from './useElementSize'

function useAppHeaderSectionObserver<T extends HTMLElement>(
  section: AppHeaderSection,
  sectionRef: RefObject<T> | MutableRefObject<T>,
) {
  const appHeaderObserver = useContext(AppHeaderContext)

  const rectObserver = useCallback<ElementBoundingClientRectObserver>((rect) => {
    appHeaderObserver(section, rect)
  }, [appHeaderObserver, section])
  useElementBoundingClientRectObserver(sectionRef, rectObserver)

  useEffect(() => {
    return () => {
      appHeaderObserver(section, undefined)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useAppHeaderSectionObserver
